import { connect } from "react-redux";
import EquipmentSummary from "./equipment-summary";
import { getEquipmentById } from "../utils";
import { onSave } from "../actions";

const mapStateToProps = (state) => ({
	equipment: getEquipmentById(state),
});

const mapDispatchToProps = {
	onSave,
};

export default connect(mapStateToProps, mapDispatchToProps)(EquipmentSummary);
